import poster1 from '../../../images/avs-video-maker/step1.png'
import video1 from '../../../images/avs-video-maker/step1.mp4'
import img1Elem from '../../../images/avs-video-maker/step1-element.png'
import img1Elem2x from '../../../images/avs-video-maker/step1-element@2x.png'

import poster2 from '../../../images/avs-video-maker/step2.png'
import video2 from '../../../images/avs-video-maker/step2.mp4'
import img2Elem from '../../../images/avs-video-maker/step2-element.png'
import img2Elem2x from '../../../images/avs-video-maker/step2-element@2x.png'

import poster3 from '../../../images/avs-video-maker/step3.png'
import video3 from '../../../images/avs-video-maker/step3.mp4'
import img3Elem from '../../../images/avs-video-maker/step3-element.png'
import img3Elem2x from '../../../images/avs-video-maker/step3-element@2x.png'

const steps = [
    {
        id: 1,
        title: 'Step 1',
        subtitle: 'Import media files',
        poster: poster1,
        video: video1,
        elem: img1Elem,
        elem2x: img1Elem2x,
    },
    {
        id: 2,
        title: 'Step 2',
        subtitle: 'Customize your video',
        poster: poster2,
        video: video2,
        elem: img2Elem,
        elem2x: img2Elem2x,
    },
    {
        id: 3,
        title: 'Step 3',
        subtitle: 'Save and export',
        poster: poster3,
        video: video3,
        elem: img3Elem,
        elem2x: img3Elem2x,
    },
]

export default steps;
